import { render, staticRenderFns } from "./SetUpAccounts.vue?vue&type=template&id=8a836f0a"
import script from "./SetUpAccounts.vue?vue&type=script&lang=ts"
export * from "./SetUpAccounts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports